import React, {Component} from 'react';

/** @class Editor
  * A component for wrapping editor tools
  * that provides some padding
  */
export default class Editor extends Component {
  /** @method render
    * Renders the component
    */
  render() {
    return (
      <div className="editor">
        {this.props.children}
      </div>
    )
  }
}

Editor.propTypes = {}



// WEBPACK FOOTER //
// ./src/editor-components/editor.js